import {useEffect} from "react";
import {getSubmit} from "ui-seeker/utils";
import {useContextSelector} from "use-context-selector";
import {CommonFiltersSavedContext} from "../../../../../context";
import {DASHBOARD} from "app/@common/constants";

export default function useList() {
    const state = useContextSelector(CommonFiltersSavedContext, ({state}) => state)
    const updateState = useContextSelector(CommonFiltersSavedContext, ({updateState}) => updateState)

    const { dataSavedFilters, isLoadingDataSavedFilters, page } = state

    const getSavedFilters = () => {
        updateState({isLoadingDataSavedFilters: true})
        getSubmit(`${DASHBOARD?.[page]?.LIST}`).then((data) => {
            updateState({ dataSavedFilters: data, isLoadingDataSavedFilters: false })
        }).catch(e => {
            updateState({ dataSavedFilters: [], isLoadingDataSavedFilters: false })
        })
    }
    useEffect(() => {
        getSavedFilters()
    }, [])

    return {
        dataSavedFilters, isLoadingDataSavedFilters, getSavedFilters
    }
}